export const IPL_TIMER_PLACEHOLDER = "{{timerPlaceholder}}";
export const MINUTES_SECONDS_TEXT = "{0}min {1}s";
export const DEFAULT_IPL_TIMER_GRADIENT = "linear-gradient(0deg, #19398C 0%, #004CD0 100%)";

const PREFIX = "ipl-swiggy-sixes-coupon-timer-tag";
export const IPL_TIMER_TAG_DATA_TEST_IDS = {
    CONTAINER: `${PREFIX}-container`,
    TEXT: `${PREFIX}-text`,
};
